import React, { useState } from 'react';
import { Text, TextName } from '../../sdk/text/Text';
import { OutlineGlassBackgroundCard } from '../outline-glass-background-card/OutlineGlassBackgroundCard';
import { TestimonialsAuthor } from './TestimonialsAuthor';
import styles from './style.module.scss';
import classNames from 'classnames';

interface TestimonialsCardProps {
  text: string;
  name: string;
  title: string;
  avatarSrc: string;
  avatarLink?: string;
  onExpandChange?: (isExpanded: boolean) => void;
}

export const TestimonialsCard: React.FC<TestimonialsCardProps> = ({
  text,
  name,
  title,
  avatarSrc,
  avatarLink,
  onExpandChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    onExpandChange?.(newExpanded);
  };

  return (
    <div
      onMouseDown={() => onExpandChange?.(true)}
      onMouseUp={() => onExpandChange?.(isExpanded)}
    >
      <OutlineGlassBackgroundCard className={styles.card}>
        <div className={styles.content}>
          <Text
            type={TextName.Text}
            className={classNames(styles.testimonialText, isExpanded && styles.expanded)}
          >
            {text}
          </Text>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleToggle();
            }}
            className={styles.readMore}
          >
            <Text type={TextName.Text}>{isExpanded ? '[see less]' : '[read more]'}</Text>
          </a>
        </div>
        <TestimonialsAuthor
          name={name}
          title={title}
          avatarSrc={avatarSrc}
          avatarLink={avatarLink}
        />
      </OutlineGlassBackgroundCard>
    </div>
  );
};
